module.exports = __webpack_public_path__ + "img/whiteAdd.72e582fa.svg";